import React from 'react';
import PropTypes from 'prop-types';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import Grid from '@mui/material/Grid';

import {
  Box,
  Typography,
} from '@mui/material';
import { setTimezones } from '../../../../../redux/app/actions';
import PlanningIcon from '../../../../../images/unused-undraw-illustrations/undraw_scrum_board_re_wk7v.svg'
import Planner from '../../../../../components/Planner';
import { getHorseLocations } from '../../../../../redux/horse/actions';
import { primary } from '../../../../../utils/brandColors';

const SchedulesCardComponent = ({ id }) => {
  const dispatch = useDispatch();

  const [sortModel] = React.useState([
    {
      field: 'startDate',
      sort: 'desc',
    },
  ]);

  // Redux state
  const currentHorseLodging = useSelector((state) => state.horse.currentHorseLodging);

  React.useEffect(() => {
    dispatch(getHorseLocations(id, 0, 5, sortModel.map((s) => `&sort=${s.field},${s.sort}`))).then((horseLocations) => {
      if (horseLocations.content.length > 0) {
        const now = new Date();
        const sublist = horseLocations.content.filter((l) => new Date(l.startDate) < now
          && (l.endDate === null || new Date(l.endDate) > now));

        // setTimezone for horse current location
        if (sublist.length > 0) {
          dispatch(setTimezones(sublist[0].location.timezone))
        }
      }
    });
  }, [id]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Box
          sx={{
            marginTop: '1rem',
            borderRadius: 2,
            backgroundColor: primary[100],
          }}
        >
          <Grid
            container
            spacing={2}
            alignItems="center"
          >
            <Grid item xs={5} sm={4} sx={{ p: 1 }}>
              <img
                src={PlanningIcon}
                alt="Scheduling Events"
                style={{
                  width: 125,
                  display: 'block',
                  margin: 'auto',
                }}
              />
            </Grid>
            <Grid item xs={7} sm={8}>
              <Typography>
                Plan &amp; review tasks and calendar events for <b>{(currentHorseLodging && currentHorseLodging.horse && currentHorseLodging.horse.name) || ''}</b>.
              </Typography>
              <Typography variant="caption" component="div">
                Setup one off or repeating tasks and calendar events with your clients including lessons,
                shows, or anything your business needs!
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={12} sx={{ pl: 2 }}>
        <Planner
          barnTasks={false}
          defaultView="calendar"
          defaultCalendarView="month"
          defaultBarnHorses={[currentHorseLodging]}
          navigate={() => { }}
        />
      </Grid>
    </Grid>
  );
};

SchedulesCardComponent.propTypes = { id: PropTypes.any.isRequired };
SchedulesCardComponent.defaultProps = {};

export default SchedulesCardComponent;
